<template>
    <div>
        <div class="card card-custom gutter-b bg-white border-0">
            <div class="card-header border-0 align-items-center">
                <h3 class="card-label mb-0 font-weight-bold text-body">
                    Дополнительная информация
                </h3>
            </div>
            <div class="card-body">
                <form>
                    <div class="form-group row">
                        <div class="col-md-6">
                            <div class="row">
                                <div class="col-md-12 ">
                                    <div
                                        class="
                  switch-h
                  d-flex
                  justify-content-between
                  align-items-center
                  border
                  p-2
                  mb-3
                "
                                    >
                                        <h4 class="font-size-h4 text-dark mb-0">Товар включен</h4>
                                        <div
                                            class="
                                                    custom-control
                                                    switch
                                                    custom-switch-info custom-switch custom-control-inline
                                                    mr-0
                                                "
                                        >
                                            <!--LV-->
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="customSwitchcolor445"
                                                :value="product_status"
                                                v-model="product_status"
                                                v-on:input="setProductStatus($event.target.value)"
                                            />
                                            <label
                                                class="custom-control-label mr-1"
                                                for="customSwitchcolor445"
                                            >
                                            </label>
                                        </div>
                                        <!--<div
                                            class="
                                                    custom-control
                                                    switch
                                                    custom-switch-info custom-switch custom-control-inline
                                                    mr-0
                                                "
                                        >
                                            EE
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="customSwitchcolor446"
                                                :value="product_status_ee"
                                                v-model="product_status_ee"
                                                v-on:input="setProductStatusEE($event.target.value)"
                                            />
                                            <label
                                                class="custom-control-label mr-1"
                                                for="customSwitchcolor446"
                                            >
                                            </label>
                                        </div>-->
                                    </div>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('product_status')"
                                        v-text="errors.get('product_status')"
                                    ></small>
                                </div>
                                <div class="col-12 mb-3">
                                    <span class="text-dark">Исключить доставку в пакоматы</span>
                                    <div class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0">
                                        <input
                                            @change="setExcludeParcel($event.target.checked)"
                                            type="checkbox"
                                            class="custom-control-input"
                                            v-model="exclude_parcel"
                                            :id="`exclude_parcel_${exclude_parcel}`"
                                            :checked="exclude_parcel"
                                        />
                                        <label class="custom-control-label mr-1" :for="`exclude_parcel_${exclude_parcel}`"></label>
                                    </div>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('exclude_parcel')"
                                        v-text="errors.get('exclude_parcel')"
                                    ></small>
                                </div>
                                <div class="col-md-12 d-none ">
                                    <div
                                        class="switch-h d-flex justify-content-between align-items-center border p-2 mb-3">
                                        <h4 class="font-size-h4 text-dark mb-0">Featured product</h4>
                                        <div
                                            class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0">
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="features"
                                                :value="is_featured"
                                                v-model="is_featured"
                                                v-on:input="setIsFeatured($event.target.value)"
                                            />
                                            <label class="custom-control-label mr-1" for="features"></label>
                                        </div>
                                    </div>
                                    <small class="form-text text-danger" v-if="errors.has('is_featured')"
                                           v-text="errors.get('is_featured')"></small>
                                </div>
                                <div class="col-md-12 d-none">
                                    <label>&nbsp;</label>
                                    <div
                                        class="switch-h d-flex justify-content-between align-items-center border p-2 mb-3">
                                        <h4 class="font-size-h4 text-dark mb-0">Is Point</h4>
                                        <div
                                            class="custom-control switch custom-switch-info custom-switch custom-control-inline mr-0 ">
                                            <input
                                                type="checkbox"
                                                class="custom-control-input"
                                                id="customSwitchcolor446"
                                                :value="is_points"
                                                v-model="is_points"
                                                v-on:input="setIsPoints($event.target.value)"
                                            />
                                            <label class="custom-control-label mr-1" for="customSwitchcolor446"></label>
                                        </div>
                                    </div>
                                    <small class="form-text text-danger" v-if="errors.has('is_points')"
                                           v-text="errors.get('is_points')"></small>
                                </div>
                                <div class="col-6">
                                    <label>Измерение товара</label>
                                    <fieldset class="form-group mb-3">
                                        <select
                                            @change="setUnit($event.target.value)"
                                            class="
                    single-select
                    w-100
                    mb-3
                    categories-select
                    ms-offscreen
                  "
                                            v-model="product_unit"
                                        >
                                            <option value="">Единицы измерения товара</option>
                                            <option v-for="unit in units" v-bind:value="unit.id">
                                                {{
                                                    unit.detail == null
                                                        ? ""
                                                        : unit.detail[0]
                                                            ? unit.detail[0].name
                                                            : ""
                                                }}
                                            </option>
                                        </select>
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('product_unit')"
                                        v-text="errors.get('product_unit')"
                                    ></small>
                                </div>
                                <div class="col-6">
                                    <label>Производитель</label>
                                    <fieldset class="form-group mb-3">
                                        <select
                                            @change="setBrand($event.target.value)"
                                            class="single-select w-100 mb-3 categories-select ms-offscreen"
                                            v-model="brand_id">
                                            <option value="">Выбрать бренд</option>
                                            <option v-for="brand in brands" v-bind:value="brand.brand_id">
                                                {{ brand.brand_name }}
                                            </option>
                                        </select>
                                    </fieldset>
                                    <small class="form-text text-danger" v-if="errors.has('brand_id')"
                                           v-text="errors.get('brand_id')"></small>
                                </div>
                                <div class="col-6">
                                    <label>Коллекция</label>
                                    <fieldset class="form-group mb-3">
                                        <select
                                            @change="setCollection($event.target.value)"
                                            class="single-select w-100 mb-3 categories-select ms-offscreen"
                                            v-model="collection_id">
                                            <option value="">Выбрать коллекцию</option>
                                            <option v-for="collection in collections" v-bind:value="collection.id">
                                                {{ collection.name }}
                                            </option>
                                        </select>
                                    </fieldset>
                                    <small class="form-text text-danger" v-if="errors.has('collection_id')"
                                           v-text="errors.get('collection_id')"></small>
                                </div>
                                <div class="col-6"></div>
                                
                                <div class="col-md-6">
                                    <label>Barcode</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="barcode"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="Ввести barcode"
                                            v-on:input="setBarcode($event.target.value)"
                                            v-model="barcode"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('barcode')"
                                        v-text="errors.get('barcode')"
                                    ></small>
                                </div>
                                <div class="col-md-6">
                                    <label>SKU</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="type-max"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="Ввести SKU"
                                            v-on:input="setProductSku($event.target.value)"
                                            v-model="sku"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('sku')"
                                        v-text="errors.get('sku')"
                                    ></small>
                                </div>
                                <div class="col-md-6">
                                    <label>EAN</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="type"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="Ввести EAN"
                                            v-on:input="setProductEan($event.target.value)"
                                            v-model="ean"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('ean')"
                                        v-text="errors.get('ean')"
                                    ></small>
                                </div>
                                <OpencartLink :product="product" :edit="edit" :errors="errors" />
                                <div class="col-md-6">
                                    <label class="text-dark">Статус при отсутствии на складе </label>
                                    <select class="form-control" v-model="availability_status" @change="setAvailabilityStatus">
                                        <option  v-for="status in availability_statuses" v-bind:value="status.code">
                                            {{ status.name }}
                                        </option>
                                    </select>
                                    <small class="form-text text-danger" v-if="errors.has('tax_id')"
                                           v-text="errors.get('tax_id')"></small>
                                </div>
                                <div class="col-md-6 d-none"></div>
                                <div class="col-md-6 d-none">
                                    <label class="text-dark">Налог </label>
                                    <select class="form-control" v-model="tax_id" @change="updateTax(tax_id)">
                                        <option v-for="tax in taxes" v-bind:value="tax.tax_id">
                                            {{ tax.tax_title }}
                                        </option>
                                    </select>
                                    <small class="form-text text-danger" v-if="errors.has('tax_id')"
                                           v-text="errors.get('tax_id')"></small>
                                </div>
                                <div class="col-md-6 d-none">
                                    <label>Цена (без НДС)</label>
                                    <fieldset class="form-group mb-3">
                                        <div class="input-group">
                                            <input
                                                type="text"
                                                class="form-control round bg-transparent text-dark"
                                                placeholder="Ввести цену"
                                                v-on:focusout="setPrice($event.target.value, 'without_vat')"
                                                v-model="price"
                                            />
                                            <div class="input-group-append">
                                                <span class="input-group-text">€</span>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('price')"
                                        v-text="errors.get('price')"
                                    ></small>
                                </div>
                                <div class="col-md-6">
                                    <div class="">
                                        <label>Цена</label>
                                        <fieldset class="form-group mb-3">
                                            <div class="input-group">
                                                <input
                                                    type="text"
                                                    class="form-control round bg-transparent text-dark"
                                                    placeholder="Ввести цену"
                                                    v-on:focusout="setPrice($event.target.value, 'with_vat')"
                                                    v-model="price_with_vat"
                                                />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">€</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <small
                                            class="form-text text-danger"
                                            v-if="errors.has('price')"
                                            v-text="errors.get('price')"
                                        ></small>
                                    </div>
                                    <div v-if="product_type == 'variable'" class="custom-control custom-checkbox mb-3">
                                        <input v-model="updateVariationsPrice" type="checkbox" id="update_variations_price" class="custom-control-input">
                                        <label for="update_variations_price" class="custom-control-label">Поменять цену у вариаций</label>
                                    </div>

                                    <!-- The wholesale price, which is otherwise the
                                         purchase price times the brand factor. A
                                         figure here wins; emptying it hands the
                                         product back to the factor. -->
                                    <div class="">
                                        <label>Цена B2B</label>
                                        <fieldset class="form-group mb-1">
                                            <div class="input-group">
                                                <input
                                                    type="number"
                                                    step="0.01"
                                                    min="0"
                                                    class="form-control round bg-transparent text-dark"
                                                    placeholder="Считается по коэффициенту бренда"
                                                    v-model="b2b_price"
                                                    @input="emitB2bPrice"
                                                    @change="emitB2bPrice"
                                                />
                                                <div class="input-group-append">
                                                    <span class="input-group-text">€</span>
                                                </div>
                                            </div>
                                        </fieldset>
                                        <small class="form-text text-muted mb-3">
                                            Пусто — цена считается по коэффициенту бренда. Заполнено — коэффициент не применяется, в том числе к вариациям.
                                        </small>
                                        <small
                                            class="form-text text-danger"
                                            v-if="errors.has('b2b_price')"
                                            v-text="errors.get('b2b_price')"
                                        ></small>
                                    </div>
                                </div>
                                <div class="col-md-6 d-none">
                                    <label>Цена со скидкой (без НДС)</label>
                                    <fieldset class="form-group mb-3">
                                        <div class="input-group">
                                            <input
                                                type="text"
                                                class="form-control round bg-transparent text-dark"
                                                placeholder="Ввести скидочную цену"
                                                v-on:focusout="setDiscountPrice($event.target.value, 'without_vat')"
                                                v-model="discount_price"
                                            />
                                            <div class="input-group-append">
                                                <span class="input-group-text" style="border: none;">€</span>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('discount_price')"
                                        v-text="errors.get('discount_price')"
                                    ></small>
                                </div>
                                <div class="col-md-6">
                                    <label>Цена со скидкой</label>
                                    <fieldset class="form-group mb-3">
                                        <div class="input-group">
                                            <input
                                                type="text"
                                                class="form-control round bg-transparent text-dark"
                                                placeholder="Ввести скидочную цену"
                                                v-on:focusout="setDiscountPrice($event.target.value, 'with_vat')"
                                                v-model="discount_price_with_vat"
                                            />
                                            <div class="input-group-append">
                                                <span class="input-group-text" style="border: none;">€</span>
                                            </div>
                                        </div>
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('discount_price')"
                                        v-text="errors.get('discount_price')"
                                    ></small>
                                </div>
                                <div class="col-md-6">
                                    <label>Скидка действует до</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="date"
                                            class="form-control round bg-transparent text-dark"
                                            v-model="discount_end_at"
                                            @change="handleDiscountEndAtChange"
                                        />
                                    </fieldset>
                                    <div v-if="product_type == 'variable'" class="custom-control custom-checkbox mb-3">
                                        <input
                                            v-model="applyDiscountEndAtToAllOptions"
                                            type="checkbox"
                                            id="apply_discount_end_at_to_all_options"
                                            class="custom-control-input"
                                            @change="handleApplyDiscountEndAtToAllOptions"
                                        >
                                        <label for="apply_discount_end_at_to_all_options" class="custom-control-label">Применить ко всем опциям</label>
                                    </div>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('discount_end_at')"
                                        v-text="errors.get('discount_end_at')"
                                    ></small>
                                </div>

                                <div class="col-md-6" v-if="edit">
                                    <label>Цена закупки</label>
                                    <fieldset class="form-group mb-3">
                                        <div class="input-group">
                                            <input
                                                v-model.number="purchase_price"
                                                type="number"
                                                step="0.01"
                                                min="0"
                                                class="form-control round bg-transparent text-dark"
                                                @blur="savePurchasePriceIfChanged"
                                            />
                                            <div class="input-group-append">
                                                <span class="input-group-text" style="border: none;">€</span>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>

                                <div class="col-md-6" v-if="edit && product_type !== 'variable'">
                                    <label>Остаток на складе</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            v-model.number="available_quantity"
                                            type="number"
                                            step="1"
                                            min="0"
                                            class="form-control round bg-transparent text-dark"
                                        />
                                    </fieldset>
                                </div>

                                <!--            <div class="col-md-6">-->
                                <!--              <label>Maximum Order</label>-->
                                <!--              <fieldset class="form-group mb-3">-->
                                <!--                <input-->
                                <!--                  type="text"-->
                                <!--                  id="type-max"-->
                                <!--                  class="form-control round bg-transparent text-dark"-->
                                <!--                  placeholder="Enter Maximum Order"-->
                                <!--                  v-on:input="setProductMaxOrder($event.target.value)"-->
                                <!--                  v-model="product_max_order"-->
                                <!--                />-->
                                <!--              </fieldset>-->
                                <!--              <small-->
                                <!--                class="form-text text-danger"-->
                                <!--                v-if="errors.has('product_max_order')"-->
                                <!--                v-text="errors.get('product_max_order')"-->
                                <!--              ></small>-->
                                <!--            </div>-->
                            </div>

                        </div>
                        <div class="col-md-6">
                            <div class="row mt-3 mt-md-0">
                                <div class="col-12 mb-3">
                                    <span>Параметры товара</span>
                                </div>
                                <div class="col-md-3 col-6">
                                    <label>Высота</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="item_height"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="см"
                                            v-on:input="setItemHeight($event.target.value)"
                                            v-model="item_height"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('item_height')"
                                        v-text="errors.get('item_height')"
                                    ></small>
                                </div>
                                <div class="col-md-3 col-6">
                                    <label>Широта</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="item_width"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="см"
                                            v-on:input="setItemWidth($event.target.value)"
                                            v-model="item_width"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('item_width')"
                                        v-text="errors.get('item_width')"
                                    ></small>
                                </div>
                                <div class="col-md-3 col-6">
                                    <label>Длина</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="item_length"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="см"
                                            v-on:input="setItemLength($event.target.value)"
                                            v-model="item_length"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('item_length')"
                                        v-text="errors.get('item_length')"
                                    ></small>
                                </div>
                                <div class="col-md-3 col-6">
                                    <label>Вес</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="item_weight"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="кг"
                                            v-on:input="setItemWeight($event.target.value)"
                                            v-model="item_weight"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('item_weight')"
                                        v-text="errors.get('item_weight')"
                                    ></small>
                                </div>
                                <div class="col-12 mb-3">
                                    <span>Параметры упаковки</span>
                                </div>
                                <div class="col-md-3 col-6">
                                    <label>Высота</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="package_height"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="см"
                                            v-on:input="setPackageHeight($event.target.value)"
                                            v-model="package_height"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('package_height')"
                                        v-text="errors.get('package_height')"
                                    ></small>
                                </div>
                                <div class="col-md-3 col-6">
                                    <label>Широта</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="package_width"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="см"
                                            v-on:input="setPackageWidth($event.target.value)"
                                            v-model="package_width"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('package_width')"
                                        v-text="errors.get('package_width')"
                                    ></small>
                                </div>
                                <div class="col-md-3 col-6">
                                    <label>Длина</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="package_length"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="см"
                                            v-on:input="setPackageLength($event.target.value)"
                                            v-model="package_length"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('package_length')"
                                        v-text="errors.get('package_length')"
                                    ></small>
                                </div>
                                <div class="col-md-3 col-6">
                                    <label>Вес</label>
                                    <fieldset class="form-group mb-3">
                                        <input
                                            type="text"
                                            id="package_weight"
                                            class="form-control round bg-transparent text-dark"
                                            placeholder="кг"
                                            v-on:input="setPackageWeight($event.target.value)"
                                            v-model="package_weight"
                                        />
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('package_weight')"
                                        v-text="errors.get('package_weight')"
                                    ></small>
                                </div>
                            </div>


                        </div>
                        <div class="col-md-12 mt-3">
                            <div class="row">
                                <div class="col-md-12">
                                    <label>Тип товара</label>
                                    <fieldset class="form-group mb-3">
                                        <select
                                            @change="setProductType($event.target.value)"
                                            class="
                                                    single-select
                                                    w-100
                                                    mb-3
                                                    categories-select
                                                    ms-offscreen
                                                  "
                                            v-model="product_type"
                                        >
                                            <option value="" disabled>Выбрать тип товара</option>
                                            <option
                                                value="simple"
                                                :disabled="product_type == 'С вариантами' && edit"
                                            >
                                                Простой
                                            </option>
                                            <option
                                                value="variable"
                                                :disabled="product_type == 'Простой' && edit"
                                            >
                                                С вариантами
                                            </option>
                                        </select>
                                        <small
                                            class="form-text text-danger"
                                            v-if="errors.has('product_type')"
                                            v-text="errors.get('product_type')"
                                        ></small>
                                    </fieldset>
                                </div>
                                <!--                                <Attributes :attributes="attributes" :errors="errors"/>-->
                                <div class="col-md-12" v-if="product_type == 'variable'">
                                    <label>Аттрибуты</label>
                                    <fieldset class="form-group mb-3 d-flex">
                                        <select
                                            class="
                    single-select
                    w-100
                    mb-3
                    categories-select
                    ms-offscreen
                  "
                                            v-model="attribute"
                                        >
                                            <option value="">Выбрать аттрибуты</option>
                                            <option
                                                v-for="attributes in attributes"
                                                v-bind:value="attributes.attribute_id"
                                                :disabled="editChild && product.attributes.length === 0"
                                            >
                                                {{
                                                    attributes.detail == null
                                                        ? ""
                                                        : attributes.detail[0]
                                                            ? attributes.detail[0].name
                                                            : ""
                                                }}
                                            </option>
                                        </select>
                                        <button
                                            type="button"
                                            @click.prevent="getVariation()"
                                            class="btn-dark btn ml-2 white pt-2 pb-1"
                                            :disabled="editChild"
                                            style="margin-bottom: 13px"
                                        >
                                            Добавить
                                        </button>
                                        <button
                                            type="button"
                                            @click.prevent="unsetVariationData()"
                                            class="btn-danger btn ml-2 white pt-2 pb-1"
                                            :disabled="editChild == true"
                                            v-show="displayClearBtn"
                                            style="margin-bottom: 13px"
                                        >
                                            Сбросить
                                        </button>
                                    </fieldset>
                                    <small
                                        class="form-text text-danger"
                                        v-if="errors.has('attributes')"
                                        v-text="errors.get('attributes')"
                                    ></small>
                                </div>
                                <template
                                    v-if="product_type == 'variable'"
                                    v-for="(variation, index) in variations"
                                >
                                    <div class="col-md-6">
                                        <label>{{
                                                variation.detail == null ? "" : variation.detail[0].name
                                            }}</label>
                                        <fieldset class="form-group mb-3 d-flex">
                                            <select
                                                class="
                      single-select
                      w-100
                      mb-3
                      categories-select
                      ms-offscreen
                    "
                                                v-model="
                      variationData['variation_' + variation.attribute_id]
                    "
                                                multiple
                                                @change="
                      setVariations('variation_' + variation.attribute_id)
                    "
                                                :disabled="editChild == true"
                                            >
                                                <option value="" selected disabled>
                                                    Select
                                                    {{
                                                        variation.detail == null ? "" : variation.detail[0].name
                                                    }}
                                                </option>
                                                <option
                                                    v-for="variationDetail in variation.variations"
                                                    v-bind:value="variationDetail.id"
                                                    :set="
                        (allVariations[variationDetail.id] =
                          variationDetail.detail == null
                            ? ''
                            : variationDetail.detail[0].name)
                      "
                                                >
                                                    {{
                                                        variationDetail.detail == null
                                                            ? ""
                                                            : variationDetail.detail[0].name
                                                    }}
                                                </option>
                                            </select>
                                        </fieldset>
                                    </div>
                                    <div class="col-md-6"></div>
                                </template>
                                <template v-if="newCombinations.length && product_type == 'variable'">
                                    <div :class="edit ? 'col-md-2' : 'col-md-4'">Опция товара</div>
                                    <div class="col-md-1 d-flex justify-content-center">SKU</div>
                                    <div class="col-md-1 d-flex justify-content-center">Barcode</div>
                                    <div v-if="edit" class="col-md-2 d-flex justify-content-center">Остаток</div>
                                    <div class="col-md-2 d-flex justify-content-center">Цена</div>
                                    <div class="col-md-2 d-flex justify-content-center">Скидочная цена</div>
                                    <div class="col-md-2 d-flex justify-content-center">Скидка до</div>
                                </template>
                                <template
                                    v-if="product_type == 'variable'"
                                    v-for="combination in newCombinations"
                                >
                                    <div class="mt-3" :class="edit ? 'col-md-2' : 'col-md-4'">
                                        {{ combination.name }}
                                    </div>
                                    <div class="col-md-1 mt-3">
                                        <fieldset class="form-group mb-3">
                                            <input
                                                type="text"
                                                class="form-control round bg-transparent text-dark"
                                                placeholder="SKU"
                                                :name="combination.sku"
                                                v-model="combination.sku"
                                            />
                                        </fieldset>
                                    </div>

                                    <div class="col-md-1 mt-3">
                                        <fieldset class="form-group mb-3">
                                            <input
                                                type="text"
                                                class="form-control round bg-transparent text-dark"
                                                placeholder="EAN"
                                                v-model="combination.ean"
                                            />
                                        </fieldset>
                                    </div>

                                    <div class="col-md-2 mt-3" v-if="edit">
                                        <fieldset class="form-group mb-3">
                                            <input
                                                v-model.number="combination.available_qty"
                                                type="number"
                                                step="1"
                                                min="0"
                                                class="form-control round bg-transparent text-dark"
                                            />
                                        </fieldset>
                                    </div>
                                    <div class="col-md-2 mt-3">
                                        <input hidden
                                               :name="combination.product_combination_id"
                                               v-model="combination.product_combination_id"
                                        />
                                        <fieldset class="form-group mb-3">
                                            <input
                                                type="text"
                                                class="form-control round bg-transparent text-dark"
                                                placeholder="см"
                                                :name="combination.price"
                                                v-model="combination.price"
                                            />
                                        </fieldset>
                                    </div>
                                    <div class="col-md-2 mt-3">
                                        <fieldset class="form-group mb-3">
                                            <input
                                                type="text"
                                                class="form-control round bg-transparent text-dark"
                                                placeholder="Discount Price"
                                                v-model="combination.discount_price"
                                            />
                                        </fieldset>
                                    </div>
                                    <div class="col-md-2 mt-3">
                                        <fieldset class="form-group mb-3">
                                            <input
                                                type="date"
                                                class="form-control round bg-transparent text-dark"
                                                v-model="combination.discount_end_at"
                                            />
                                        </fieldset>
                                    </div>
                                </template>
                                <!-- <template
                                  v-if="product_type == 'variable' && edit == 1"
                                  v-for="(editame, index) in edit_variation_name"
                                >
                                  <template v-if="index == 0">
                                    <div class="col-md-3">Variant</div>
                                    <div class="col-md-3">Variat Price</div>
                                    <div class="col-md-3">SKU</div>
                                    <div class="col-md-3">Image</div>
                                  </template>

                                  <div class="col-md-3 mt-3">
                                    {{ editame }}
                                  </div>
                                  <div class="col-md-3 mt-3">
                                    <input type="text" v-model="edit_combinationPrice[index]" />
                                  </div>
                                  <div class="col-md-3 mt-3">
                                    <input type="text" v-model="edit_combinationSku[index]" />
                                  </div>
                                  <div class="col-md-3 mt-3">
                                    <img
                                      v-if="
                                        edit_combinationGalleryPath[index] != '' &&
                                        edit_combinationGalleryPath[index] != null
                                      "
                                      :src="edit_combinationGalleryPath[index]"
                                      style="width: 100px; height: 100px"
                                    />
                                  </div>
                                </template> -->
                            </div>
                        </div>


                    </div>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex justify-content-between">
                <button
                data-toggle="pill"
                class="btn btn-primary cta"
                @click="syncQty()"
            >Синхронизировать количество</button>
            <div class="d-flex justify-content-end">
                <a style="margin-right: 10px"
                   data-toggle="pill"
                   @click.prevent="setActive('info-tab')"
                   :class="{ active: isActive('info-tab') }"
                   class="btn btn-dark swipe-to-top cta"
                >Назад</a
                >
                <a
                    data-toggle="pill"
                    href="#"
                    class="btn btn-primary cta"
                    @click.prevent="addProduct()"
                >Сохранить</a
                >
            </div>
            </div>
        </div>
        <attach-image
            @toggleImageSelect="toggleImageSelect"
            :showModal="showModal"
            @setImage="setImage"
        />
    </div>
</template>

<script>
import OpencartLink from './OpencartLink.vue';
import Attributes from './Attributes';

export default {
    components: {
        Attributes,
        OpencartLink,
    },
    data() {
        return {
            csrf: document
                .querySelector('meta[name="csrf-token"]')
                .getAttribute("content"),
            units: [],
            taxes: [],
            newCombinations: [],
            new_sku: [],
            brands: [],
            collections: [],
            attributes: [],
            variations: [],
            product_type: "",
            attribute: "",
            selectedAttribute: [],
            product_status: true,
            product_status_ee: true,
            is_featured: true,
            is_points: true,
            product_unit: "",
            product_weight: "",
            brand_id: "",
            collection_id: "",
            price: "",
            price_with_vat: "",
            b2b_price: "",
            sku: "",
            ean: "",
            discount_price: "",
            discount_price_with_vat: "",
            discount_end_at: "",
            product_min_order: 1,
            product_max_order: 5,
            combinationPrice: {},
            combinationSku: {},
            combinationGallery: {},
            combinationGalleryPath: {},
            variationData: {},
            combinations: [],
            combinationDetail: [],
            allVariations: [],
            showModal: false,
            currentSelectedGalleryName: "",
            lastSku: "",
            token: [],
            edit_combination_detail: [],
            editChild: false,
            displayClearBtn: 1,
            edit_variation_name: [],
            edit_combinationPrice: [],
            edit_combinationSku: [],
            edit_combinationGalleryPath: [],
            edit_combinationGallery: [],
            barcode: '',
            package_width: '',
            package_height: '',
            available_quantity: 0,
            purchase_price: 0,
            package_length: '',
            package_weight: '',
            item_width: '',
            item_height: '',
            item_length: '',
            item_weight: '',
            tax_id: '',
            availability_status: '',
            exclude_parcel: true,
            availability_statuses: {
                1: {
                    'name': 'Есть в наличии',
                    'code': 'in',
                },
                // 2: {
                //     'name': 'Есть в наличии (в магазине)',
                //     'code': 'in_store',
                // },
                // 3: {
                //     'name': 'Есть в наличии (На складе)',
                //     'code': 'in_stock',
                // },
                4: {
                    'name': 'Нет в наличии',
                    'code': 'out_of_stock',
                },
                5: {
                    'name': 'Предзаказ',
                    'code': 'preorder',
                },
                6: {
                    'name': '2-3 дня',
                    'code': '2_3_days',
                },
		10: {
		    'name': 'Доставка от 4 до 8 недель',
		    'code': '4-8_weeks', 
		},
            },
            selected_tax: [],
            savedCombinations: null,
            updateVariationsPrice: false,
            applyDiscountEndAtToAllOptions: false,
        };
    },
    methods: {
        getLastPurchasePrice(){
            return this.product.last_purchase != null ? this.product.last_purchase.price : null;
        },
        syncQty(){
            this.$parent.$parent.loading = true;
            axios
                .post("/api/admin/syncqnt", {
                    product_id: this.$route.params.id,
                }, this.token)
                .then((res) => {
                    if(res.data.status == "Success"){
                        this.$toaster.success(res.data.message);
                    }else{
                        this.$toaster.error(res.data.message);
                    }
                })
                .catch((error) => {this.$toaster.error('Something went wrong!')})
                .finally(() => {
                    this.$parent.$parent.loading = false
                });
        },

        fetchUnits() {
            this.$parent.$parent.loading = true;
            let token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            axios
                .get("/api/admin/unit?getAllData=1&getDetail=1&onlyActive=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.units = res.data.data;
                    }
                })
                .finally(() => (this.$parent.$parent.loading = false));
        },
        fetchAttributes() {
            this.$parent.$parent.loading = true;
            let token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            axios
                .get("/api/admin/attribute?getAllData=1&getDetail=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.attributes = res.data.data;
                    }
                })
                .finally(() => (this.$parent.$parent.loading = false));
        },
        fetchBrands() {
            this.$parent.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};

            axios
                .get("/api/admin/brand?getAllData=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.brands = res.data.data;
                    }
                })
                .finally(() => (this.$parent.$parent.loading = false));
        },
        fetchCollections() {
            this.$parent.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };

            axios
                .get("/api/admin/collection?getAllData=1", config)
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.collections = res.data.data;
                    }
                })
                .finally(() => (this.$parent.$parent.loading = false));
        },
        fetchTaxes() {
            this.$parent.loading = true;
            var token = localStorage.getItem('token');
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };
            var responseData = {};

            axios.get('/api/admin/tax?getAllData=1', config)
                .then(res => {
                    if (res.data.status == "Success") {
                        this.taxes = res.data.data;
                        //always tax_id set to 21%
                        this.updateTax(2);

                    }
                }).finally(() => (this.$parent.loading = false));
        },
        setUnit(value) {
            this.$emit("setUnitInChild", value);
        },
        setBrand(value) {
            this.$emit("setBrandInChild", value);
        },
        setCollection(value) {
            this.$emit("setCollectionInChild", value);
        },
        setProductWeight(value) {
            this.$emit("setProductWeightInChild", value);
        },
        setBarcode(value) {
            this.$emit("setBarcode", value);
        },
        setPackageWidth(value) {
            this.$emit("setPackageWidth", value);
        },
        setPackageHeight(value) {
            this.$emit("setPackageHeight", value);
        },
        setPackageLength(value) {
            this.$emit("setPackageLength", value);
        },
        setPackageWeight(value) {
            this.$emit("setPackageWeight", value);
        },
        setItemWidth(value) {
            this.$emit("setItemWidth", value);
        },
        setItemHeight(value) {
            this.$emit("setItemHeight", value);
        },
        setItemLength(value) {
            this.$emit("setItemLength", value);
        },
        setItemWeight(value) {
            this.$emit("setItemWeight", value);
        },
        setProductMinOrder(value) {
            this.$emit("setProductMinOrderInChild", value);
        },
        setProductMaxOrder(value) {
            this.$emit("setProductMaxOrderInChild", value);
        },
        setProductSku(value) {
            this.$emit("setProductSkuInChild", value);
        },
        setProductEan(value) {
            this.$emit("setProductEanInChild", value)
        },
        setAvailabilityStatus() {
            console.log(this.availability_status);
            this.$emit("setAvailabilityStatus", this.availability_status)
        },
        setExcludeParcel(value) {
            this.$emit("setExcludeParcel", value);
        },
        setPrice(value, field) {
            if(field === 'with_vat') {
                if(this.selected_tax.tax_rate>0) {
                    value = value/(this.selected_tax.tax_rate/100 + 1)
                    this.price = value;
                }
            } else {
                if(this.selected_tax.tax_rate>0) {
                    this.price_with_vat = value*(this.selected_tax.tax_rate/100 + 1);
                }
            }
            value = parseFloat(value).toFixed(2);
            this.price_with_vat = parseFloat(this.price_with_vat).toFixed(2);
            this.price = parseFloat(this.price).toFixed(2);
            this.$emit("setPriceInChild", this.price);
            this.$emit("setPriceWithVatInChild", this.price_with_vat);

            this.updateVariationPrices();
        },
        emitB2bPrice() {
            this.$emit("setB2bPriceInChild", this.b2b_price === '' ? null : this.b2b_price);
        },
        setDiscountPrice(value, field) {
            if(field === 'with_vat') {
                if(this.selected_tax.tax_rate>0) {
                    // value = value/(this.selected_tax.tax_rate/100 + 1)
                    this.discount_price = value;
                }
            } else {
                if(this.selected_tax.tax_rate>0) {
                    this.discount_price_with_vat = value*(this.selected_tax.tax_rate/100 + 1);
                }
            }
            if(value) {
                value = parseFloat(value).toFixed(2);
                this.discount_price_with_vat = parseFloat(this.discount_price).toFixed(2);
                this.discount_price = parseFloat(this.discount_price).toFixed(2);
                this.$emit("setDiscountPriceInChild", value);
            } else {
                console.log(value);
                this.discount_price_with_vat = '';
                this.discount_price = '';
                this.$emit("setDiscountPriceInChild", '0.00');
            }

        },
        handleDiscountEndAtChange() {
            this.$emit('setDiscountEndAtInChild', this.discount_end_at);

            if (this.applyDiscountEndAtToAllOptions) {
                this.applyDiscountEndAtToVariations();
            }
        },
        handleApplyDiscountEndAtToAllOptions() {
            if (this.applyDiscountEndAtToAllOptions) {
                this.applyDiscountEndAtToVariations();
            }
        },
        applyDiscountEndAtToVariations() {
            if (this.product_type !== 'variable' || !this.newCombinations.length) {
                return;
            }

            this.newCombinations.forEach((combination) => {
                combination.discount_end_at = this.discount_end_at || '';
            });

            this.$emit('setCombinations', this.newCombinations);
        },
        updateVariationPrices() {
            if (!this.updateVariationsPrice) {
                return;
            }

            this.newCombinations.forEach((combination) => {
                combination.price = this.price_with_vat;
            });
        },
        setProductType(value) {
            this.$emit("setProductTypeInChild", value);
        },
        setProductStatus(value) {
            this.$emit("setProductStatusInChild", value);
        },
        setProductStatusEE(value) {
            this.$emit("setProductStatusEEInChild", value);
        },
        setIsFeatured(value) {
            this.$emit("setIsFeaturedInChild", value);
        },
        setIsPoints(value) {
            this.$emit("setIsPointsInChild", value);
        },

        setAttributes(value) {
            this.$emit("setAttributesInChild", value);
        },
        isActive(value) {
            this.$emit("isActiveInChild", value);
        },
        setActive(value) {
            this.$emit("setActiveInChild", value);
        },
        setCombinationPrice(name, price) {
            var newprice = price != null ? price : this.price;
            if (this.combinationPrice[name] == null) {
                this.combinationPrice[name] = newprice;
            }
            this.$emit("setCombinationPriceInChild", name, newprice);
        },
        setCombinationSku(name, sku) {
            console.log(name, sku);
            var newsku = sku != null ? sku : this.sku;

            this.$emit("setCombinationSkuInChild", name, newsku);
        },
        setCombinationGallery(name) {
            if (this.combinationGallery[name] == null) {
                this.combinationGallery[name] = 0;
            }
            this.$emit(
                "setCombinationGalleryInChild",
                name,
                this.combinationGallery[name]
            );
        },
        unsetVariationData() {
            this.variations = [];
            this.selectedAttribute = [];
            this.combinationDetail = [];
            this.combinationPrice = {};
            this.combinationSku = {};
            this.combinationGallery = {};
            this.combinations = [];
            this.newCombinations = [];

            this.combinationGalleryPath = {};

            for (const [key, value] of Object.entries(this.variationData)) {
                console.log(`${key}: ${value}`);
                this.$emit("unsetVariationInChild", key);

            }
            this.variationData = {};


        },
        setVariations(name) {
            if (this.edit == 0 && this.price == "") {
                this.$toaster.error('Price Field can"t be empty');
                return;
            }

            this.$emit("setVariationsInChild", name, this.variationData[name]);
            // Check variation is selected against every attribute
            var totalVariations = 0;

            for (var i = 0; i < this.selectedAttribute.length; i++) {
                // console.log(this.variationData[i]);
                if (
                    this.variationData["variation_" + this.selectedAttribute[i]].length >
                    0
                ) {
                    totalVariations = parseInt(totalVariations) + 1;
                }
            }

            if (this.selectedAttribute.length != totalVariations) {
                this.combinationDetail = [];
                return;
            }
            if (this.edit == 0) {
                this.displayClearBtn = 1;
            }

            // create product combinations
            this.combinationDetail = [];
            this.combinationPrice = {};
            this.combinationSku = {};
            this.combinationGallery = {};
            this.combinations = [];
            for (var i = 0; i < this.selectedAttribute.length; i++) {
                this.combinations.push(
                    this.variationData["variation_" + this.selectedAttribute[i]]
                );
            }

            this.makeCombinationData();
        },

        getCombinationNameById(ids){
            return ids.map(item => this.allVariations[item]).join(' - ');
        },

        makeCombinationData() {
            this.newCombinations = [];
            const combinationsId = this.cartesian(this.combinations);
            combinationsId.forEach((combinationId, index) => {
                const savedCombination = this.product.combination_detail && this.product.combination_detail.length ?
                    this.product.combination_detail.find((item) => {
                        return item.combination.every((search) => {
                            return combinationId.find(id => +id === +search.variation_id);
                        });
                    }) || {} : {}

                console.log(this.price)
                this.newCombinations.push({
                    name: this.getCombinationNameById(combinationId),
                    sku: savedCombination.sku || (this.sku ? `${this.sku}-${index + 1}` : ""),
                    price: savedCombination.price || this.price_with_vat,
                    discount_price: savedCombination.product_discount_price || this.discount_price_with_vat,
                    discount_end_at: savedCombination.discount_end_at || (this.applyDiscountEndAtToAllOptions ? this.discount_end_at : ''),
                    ean: savedCombination.ean || `${this.ean}-${index + 1}`,
                    product_combination_id: savedCombination.product_combination_id || '',
                    order: savedCombination.order || index,
                    variation: combinationId,
                    available_qty: savedCombination.available_qty || 0,
                    isEditingQty: false,
                })
            })
            this.$emit('setCombinations', this.newCombinations);
            console.log(this.newCombinations)
            // name sku price discount_price ean
            console.log(this.combinations)
            //console.log(res);
            // var new_sku, sku_no;
            // new_sku = this.lastSku;
            // for (var i = 0; i < res.length; i++) {
            //     var arr = {};
            //     var price = "combination_price_";
            //     var sku = "combination_sku_";
            //     var gallary = "combination_gallary_";
            //     var variation_name = "";
            //     for (var j = 0; j < res[i].length; j++) {
            //         if (this.allVariations[res[i][j]] == null) {
            //             continue;
            //         }
            //         if (res[i].length - 1 == j) {
            //             if (!this.edit) {
            //                 arr.new_sku = this.sku + "-" + (i + 1);
            //                 arr.price = this.price;
            //             }
            //             variation_name +=
            //                 this.allVariations[res[i][j]] == null
            //                     ? ""
            //                     : this.allVariations[res[i][j]];
            //             arr.variation_name = variation_name;
            //
            //             arr.price = price + res[i][j];
            //             arr.sku = sku + res[i][j];
            //             arr.gallary = gallary + res[i][j];
            //             if (!this.edit) {
            //                 this.setCombinationPrice(arr.price, null);
            //                 this.combinationSku[arr.sku] = arr.new_sku;
            //                 this.setCombinationSku(arr.sku, null);
            //             }
            //         } else {
            //             variation_name +=
            //                 this.allVariations[res[i][j]] == null
            //                     ? ""
            //                     : this.allVariations[res[i][j]] + " - ";
            //
            //             price = price + res[i][j] + "_";
            //             sku = sku + res[i][j] + "_";
            //             gallary = gallary + res[i][j] + "_";
            //         }
            //     }
            //     if (arr.hasOwnProperty("price") != false) {
            //         this.combinationDetail.push(arr);
            //     }
            // }
            // console.log(this.combinationDetail)
            // // console.log(this.edit_combination_detail.length);
            // if (
            //     this.combinationDetail.length > 0 &&
            //     this.edit_combination_detail.length > 0
            // ) {
            //     for (var i = 0; i < res.length; i++) {
            //         var variation_id = [];
            //         var price_name = "combination_price_";
            //         var sku_name = "combination_sku_";
            //         var gallary_name = "combination_gallary_";
            //         for (var j = 0; j < res[i].length; j++) {
            //
            //             variation_id.push(parseInt(res[i][j]));
            //             if (res[i].length - 1 == j) {
            //                 price_name = price_name + res[i][j];
            //                 sku_name = sku_name + res[i][j];
            //                 gallary_name = gallary_name + res[i][j];
            //                 for (var j = 0; j < this.edit_combination_detail.length; j++) {
            //                     var is_combination = [];
            //                     var edit_variation_id = [];
            //                     for (
            //                         var jj = 0;
            //                         jj < this.edit_combination_detail[j].combination.length;
            //                         jj++
            //                     ) {
            //                         console.log(variation_id.indexOf(
            //                             this.edit_combination_detail[j].combination[jj]
            //                                 .variation_id
            //                         ), variation_id, parseInt(this.edit_combination_detail[j].combination[jj]
            //                             .variation_id), "edit variation id")
            //                         if (
            //                             variation_id.indexOf(
            //                                 parseInt(this.edit_combination_detail[j].combination[jj]
            //                                     .variation_id)
            //                             ) !== -1
            //                         ) {
            //                             is_combination.push(1);
            //                             console.log("is_combination push 1")
            //                         } else {
            //                             console.log("is_combination push 0")
            //                             is_combination.push(0);
            //                         }
            //                     }
            //                     if (is_combination.indexOf(0) == -1) {
            //                         console.log(price_name + ' => ' + this.edit_combination_detail[j].price);
            //                         this.combinationPrice[price_name] =
            //                             this.edit_combination_detail[j].price;
            //                         this.setCombinationPrice(
            //                             price_name,
            //                             this.edit_combination_detail[j].price
            //                         );
            //                         this.combinationSku[sku_name] =
            //                             this.edit_combination_detail[j].sku;
            //
            //                         this.setCombinationSku(
            //                             sku_name,
            //                             this.edit_combination_detail[j].sku
            //                         );
            //                         this.combinationGalleryPath[gallary_name] =
            //                             "/gallary/" +
            //                             this.edit_combination_detail[j].gallary.gallary_name;
            //                         this.combinationGallery[gallary_name] =
            //                             this.edit_combination_detail[j].gallary.id;
            //                         this.setCombinationGallery(gallary_name);
            //                     }
            //                 }
            //             } else {
            //                 price_name = price_name + res[i][j] + "_";
            //                 sku_name = sku_name + res[i][j] + "_";
            //                 gallary_name = gallary_name + res[i][j] + "_";
            //             }
            //         }
            //     }
            // }
        },
        // makeEditCombination() {
        //   for (var j = 0; j < this.edit_combination_detail.length; j++) {
        //     var variation_name = "(";
        //     for (
        //       var jj = 0;
        //       jj < this.edit_combination_detail[j].combination.length;
        //       jj++
        //     ) {
        //       variation_name +=
        //         this.edit_combination_detail[j].combination[jj].variation.detail[0]
        //           .name + " ";
        //     }
        //     variation_name += ")";
        //     this.edit_variation_name[j] = variation_name;
        //     this.edit_combinationPrice[j] = this.edit_combination_detail[j].price;
        //     this.edit_combinationSku[j] = this.edit_combination_detail[j].sku;
        //     this.edit_combinationGalleryPath[j] =
        //       "/gallary/" + this.edit_combination_detail[j].gallary.gallary_name;
        //     this.edit_combinationGallery[j] =
        //       this.edit_combination_detail[j].gallary.id;
        //   }
        // },
        formatNumberLength(num, length) {
            var r = "" + num;
            while (r.length < length) {
                r = "0" + r;
            }
            return r;
        },

        searchVariationName(variation_id) {
            for (var i = 0; i < this.variations.length; i++) {
                for (var j = 0; i < this.variations[i].variations.length; j++) {
                    if (this.variations[i].variations[j].id == variation_id) {
                        return this.variations[i].variations[j].detail == null
                            ? ""
                            : this.variations[i].variations[j].detail[0].name;
                    }
                }
            }
        },

        cartesian(args) {
            var r = [],
                max = args.length - 1;

            function helper(arr, i) {
                for (var j = 0, l = args[i].length; j < l; j++) {
                    var a = arr.slice(0); // clone arr
                    a.push(args[i][j]);
                    if (i == max) r.push(a);
                    else helper(a, i + 1);
                }
            }

            helper([], 0);
            return r;
        },
        async getVariation() {
            console.log(this.attribute);
            if(this.attribute == '') {
                return false;
            }
            this.$parent.$parent.loading = true;
            var token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            };
            var responseData = {};
            console.log('click')

            if (this.selectedAttribute.indexOf(this.attribute) < 0) {
                this.selectedAttribute.push(this.attribute);
                this.setAttributes(this.attribute);
            } else {
                this.$parent.$parent.loading = false;
                return false;
            }
            var name = "variation_" + this.attribute;
            this.$set(this.variationData, name, []);

            await axios
                .get(
                    "/api/admin/attribute/" +
                    this.attribute +
                    "?getVariation=1&getDetail=1",
                    config
                )
                .then((res) => {
                    if (res.data.status == "Success") {
                        this.variations.push(res.data.data);
                        // this.variations = res.data.data;
                    }
                })
                .finally(() => (this.$parent.$parent.loading = false));
        },
        toggleImageSelect(name) {
            this.showModal = !this.showModal;
            this.currentSelectedGalleryName = name;
        },
        setImage(gallary) {
            // console.log(gallary);
            this.combinationGalleryPath[this.currentSelectedGalleryName] =
                gallary.gallary_path;
            this.combinationGallery[this.currentSelectedGalleryName] =
                gallary.gallary_id;
            this.setCombinationGallery(this.currentSelectedGalleryName);
        },
        addProduct() {
            this.$emit('addProductInChild');
        },
        updateTax(value) {
            this.$emit("setTaxId", value);
            this.selected_tax = this.taxes.find(x => x.tax_id == value);

            console.log(this.selected_tax);
            console.log(value);
        },

        savePurchasePriceIfChanged() {
            if (!this.edit || !this.product || !this.product.product_id) {
                return;
            }

            // Check if purchase price changed
            const originalPrice = this.product.last_purchase ? this.product.last_purchase.price : 0;
            if (this.purchase_price === originalPrice) {
                return; // No change, don't save
            }

            const token = localStorage.getItem("token");
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };

            const data = {
                purchase_price: this.purchase_price
            };

            axios.put(`/api/admin/product/${this.product.product_id}/purchase-price`, data, config)
                .then((res) => {
                    if (res.data.status === 'Success') {
                        // Update the last_purchase in product to avoid re-saving
                        if (this.product.last_purchase) {
                            this.product.last_purchase.price = this.purchase_price;
                        }
                        this.$toasted.show('Цена закупки сохранена', {
                            type: 'success',
                            duration: 2000
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error saving purchase price:', error);
                    this.$toasted.show('Ошибка при сохранении цены закупки', {
                        type: 'error',
                        duration: 3000
                    });
                });
        },
    },
    watch: {
        product(newVal, oldVal) {
            console.log(newVal, "newval");
            // this.editChild = this.$parent.edit;
            this.applyDiscountEndAtToAllOptions = false;
            this.product_type = newVal.product_type;
            this.sku = newVal.sku;

            this.product_status = newVal.product_status == "inactive" ? 0 : 1;
            this.product_status_ee = newVal.product_status_ee == "inactive" ? 0 : 1;
            this.is_featured =
                newVal.is_featured == true || newVal.is_featured == "true" ? 1 : 0;
            this.is_points =
                newVal.is_points == true || newVal.is_points == "true" ? 1 : 0;
            this.exclude_parcel =
                newVal.exclude_parcel == true || newVal.exclude_parcel == "true" ? 1 : 0;
            this.product_unit = newVal.product_unit;
            this.brand_id = newVal.brand_id;
            this.collection_id = newVal.collection_id;
            this.selected_tax = newVal.tax;
            this.price = parseFloat(newVal.price);
            this.price_with_vat = parseFloat(newVal.price_with_vat);
            // Empty rather than 0 when the product has no price of its own: the
            // field means "worked out from the factor", and a zero in it would
            // read as a price of nothing.
            this.b2b_price = (newVal.b2b_price === null || typeof newVal.b2b_price === 'undefined' || newVal.b2b_price === '')
                ? ''
                : newVal.b2b_price;
            this.discount_price = parseFloat(newVal.discount_price);
            this.discount_end_at = newVal.discount_end_at || '';
            if(this.selected_tax.tax_rate>0) {
                if(this.discount_price>0) {
                    // this.discount_price_with_vat = this.discount_price*(this.selected_tax.tax_rate/100 + 1);
                    this.discount_price_with_vat = this.discount_price;
                }
            } else {
                this.discount_price_with_vat = this.discount_price;
            }
            if(this.discount_price_with_vat>0) {
                this.discount_price_with_vat = this.discount_price_with_vat.toFixed(2);
            }
            this.tax_id = newVal.tax_id;
            this.ean = newVal.ean;
            this.availability_status = newVal.availability_status;
            // this.exclude_parcel = newVal.exclude_parcel || 0;

            // Initialize purchase price
            if (newVal.last_purchase && newVal.last_purchase.price) {
                this.purchase_price = parseFloat(newVal.last_purchase.price);
            } else {
                this.purchase_price = 0;
            }

            // Initialize available quantity for simple products
            if (newVal.product_type !== 'variable') {
                if (newVal.available_quantity !== undefined) {
                    this.available_quantity = newVal.available_quantity;
                } else if (newVal.stocks && newVal.stocks.length > 0) {
                    this.available_quantity = newVal.stocks.reduce((sum, stock) => sum + stock.remaining, 0);
                } else {
                    this.available_quantity = 0;
                }
            }

            this.barcode = newVal.barcode;
            this.package_width = newVal.package_width;
            this.package_height = newVal.package_height;
            this.package_length = newVal.package_length;
            this.package_weight = newVal.package_weight;
            this.item_width = newVal.item_width;
            this.item_height = newVal.item_height
            this.item_length = newVal.item_length;
            this.item_weight = newVal.item_weight;


            this.product_max_order = newVal.product_max_order;
            this.product_min_order = newVal.product_min_order;
            this.product_weight = newVal.product_weight;


            console.log(this.ean, "sku");
            if (newVal.product_type == "variable") {
                this.edit_combination_detail = newVal.combination_detail; //not used
                newVal.attributes.map((attribute_id, index) => {
                    this.attribute = attribute_id;
                    this.getVariation().then(() => {
                        for (
                            var i = 0;
                            i < newVal.combination[attribute_id].variations.length;
                            i++
                        ) {
                            this.variationData["variation_" + attribute_id].push(
                                newVal.combination[attribute_id].variations[i].product_variation
                                    .id
                            );
                        }
                        this.setVariations("variation_" + attribute_id);
                    });

                    // this.setVariations('variation_'+attribute_id);
                });
            }
        },
        updateVariationsPrice(isChecked) {
        if (isChecked) {
            this.updateVariationPrices();
        }
        },
        purchase_price(newVal) {
            this.$emit("setPurchasePriceInChild", newVal);
        },
        available_quantity(newVal) {
            this.$emit("setAvailableQuantityInChild", newVal);
        }
    },
    mounted() {
        var token = localStorage.getItem("token");
        this.token = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };
        this.fetchUnits();
        this.fetchBrands();
        this.fetchCollections();
        this.fetchAttributes();
        this.fetchTaxes();

        // Load available quantity if editing
        if (this.edit && this.product.stocks) {
            this.available_quantity = this.product.stocks.reduce((sum, stock) => sum + stock.remaining, 0);
        }
    },
    props: ["product", "errors", "edit"],
};
</script>
